export var setLoading = () => {
	return {
		type: "SET_LOADING"
	};
};

export var setSaving = () => {
	return {
		type: "SET_SAVING"
	};
};

export var setSearching = () => {
	return {
		type: "SET_SEARCHING"
	};
};

export var setSending = () => {
	return {
		type: "SET_SENDING"
	};
};

export var setDeleting = () => {
	return {
		type: "SET_DELETING"
	};
};

export var setUploading = (index, total) => {
	return {
		type: "SET_UPLOADING",
		index,
		total
	};
};

export var resetLoading = () => {
	return {
		type: "RESET_LOADING"
	};
};

export var resetSearching = () => {
	return resetLoading();
}

export var removeLoading = () => {
	return {
		type: "POP_LOADING"
	};
}


// WEBPACK FOOTER //
// ./src/actions/loadingActions.js